import HomePage from './HomePage';

export default function EnPage() {
    return <HomePage formatoId={1} />;
}
